var _rect, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisconnect = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 96,
  height: 96,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  fill: "#071722",
  fillOpacity: 0.02,
  rx: 48
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#92999E",
  fillRule: "evenodd",
  d: "M34 33.625A2.375 2.375 0 0 0 31.625 36v23.528A3.375 3.375 0 0 0 35 62.903h26.836a3.375 3.375 0 0 0 3.375-3.375v-18.39a2.375 2.375 0 0 0-2.375-2.376H49.642a.625.625 0 0 1-.442-.183l-4.954-4.954H34ZM30.375 36A3.625 3.625 0 0 1 34 32.375h10.505c.166 0 .325.066.442.183l4.954 4.954h12.935a3.625 3.625 0 0 1 3.625 3.625v18.391a4.625 4.625 0 0 1-4.625 4.625H35a4.625 4.625 0 0 1-4.625-4.625V36Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M35.55 46.156a3 3 0 0 1 2.903-2.24h29.956a2 2 0 0 1 1.934 2.507L66.45 61.288a3 3 0 0 1-2.903 2.24h-28.66a3 3 0 0 1-2.902-3.76l3.565-13.612Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#92999E",
  fillRule: "evenodd",
  d: "M34.946 45.998a3.625 3.625 0 0 1 3.507-2.707h29.956a2.625 2.625 0 0 1 2.539 3.29l-3.894 14.866a3.625 3.625 0 0 1-3.507 2.706h-28.66a3.625 3.625 0 0 1-3.507-4.544l3.566-13.611Zm3.507-1.457c-1.08 0-2.024.729-2.298 1.773l-3.566 13.612a2.375 2.375 0 0 0 2.298 2.977h28.66c1.08 0 2.024-.728 2.298-1.773l3.894-14.866a1.375 1.375 0 0 0-1.33-1.723H38.452Z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 60,
  r: 9,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--mb-color-error)",
  fillRule: "evenodd",
  d: "M72 60a6 6 0 0 1-9.476 4.89l8.367-8.366C71.589 57.504 72 58.704 72 60Zm-10.89 3.477 8.367-8.368a6 6 0 0 0-8.367 8.367ZM74 60a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisconnect);
export default ForwardRef;